export default __webpack_public_path__ + "static/media/GARMIN.43a04544.png";